import { warn } from "@swivl-mono/helpers";
import { LocationPageInterface, LocationVarInheritance, LocationVarKey } from "@swivl-mono/types";
import { Button, ButtonColor, ImageUploader, ImageUploaderType } from "@swivl-mono/ui";
import { BiEdit } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

import { useMergedLocationVariables } from "../../../../Hooks/useLocationVariables";
import LocationsModel from "../../../../Models/Locations/Locations.Model";
import LocationVarsModel from "../../../../Models/Variables/LocationVars.Model";
import "./Location.Details.Header.scss";

interface LocationDetailsHeaderProps extends LocationPageInterface {
  children: React.ReactNode;
}

export function LocationDetailsHeader(props: LocationDetailsHeaderProps) {
  const { groups, locations } = LocationsModel.useState();

  const vars = useMergedLocationVariables(
    [
      LocationVarKey.Name,

      LocationVarKey.AvatarURL,
      LocationVarKey.Address,
      LocationVarKey.City,
      LocationVarKey.State,
      LocationVarKey.PostalCode,
      LocationVarKey.CountryCode,
    ],
    props.groupId,
    props.locationId,
  );

  const { location, group } = props;
  const navigate = useNavigate();

  let name = "NAME";
  let subText = "";
  let subText2 = "";

  let infoContent: React.ReactNode = null;
  if (props.locationId) {
    if (location) {
      name = vars?.[LocationVarKey.Name]?.value || "";
      subText = vars?.[LocationVarKey.Address]?.value ? vars?.[LocationVarKey.Address]?.value + " " : "";
      subText2 += vars?.[LocationVarKey.City] ? vars?.[LocationVarKey.City].value + ", " : "";

      subText2 += vars?.[LocationVarKey.State]?.value ? vars?.[LocationVarKey.State]?.value + " " : "";
      subText2 += vars?.[LocationVarKey.PostalCode]?.value ? vars?.[LocationVarKey.PostalCode]?.value + " " : "";
      subText2 +=
        vars?.[LocationVarKey.CountryCode]?.value && vars?.[LocationVarKey.CountryCode]?.value !== "US"
          ? vars?.[LocationVarKey.CountryCode]?.value
          : "";
    }
  } else if (props.groupId) {
    if (group) {
      name = vars?.[LocationVarKey.Name]?.value || "";
      subText = group.locations?.length ? group.locations.length + " Locations" : "0 Locations";
      infoContent = (
        <div className="info">
          You're editing <b>group</b> settings. These will apply to all locations within this group. Customizations at the location level will remain
          intact.
        </div>
      );
    }
  } else {
    name = vars?.[LocationVarKey.Name]?.value || "";
    if (groups?.length) {
      subText += groups.length + " Groups \n";
    }
    if (locations?.length) {
      subText += locations.length + " Locations";
    }
    infoContent = (
      <div className="info">
        You're editing <b>global</b> settings across your entire organization. These will apply to all groups and locations. Customizations at the
        group or location level will remain intact.
      </div>
    );
  }

  return (
    <div className="LocationDetailsHeader">
      <div className="background">
        <img src={vars?.[LocationVarKey.AvatarURL]?.value} alt={`Avatar for: ${name}`} />
      </div>
      <div className="heading">
        <ImageUploader
          isEditable={props.isEditing}
          text="Click to Upload"
          type={ImageUploaderType.LOCATION}
          imageURL={vars?.[LocationVarKey.AvatarURL]?.value}
          imageUploaded={(url) => {
            const varId = vars?.[LocationVarKey.AvatarURL]?.id;
            if (vars?.[LocationVarKey.AvatarURL]?.inheritance === LocationVarInheritance.NONE) {
              if (!varId) {
                warn("No varId found for AvatarURL");
              }
              LocationVarsModel.saveVariable(varId!, url);
            }

            LocationVarsModel.createVariable(
              LocationVarKey.AvatarURL,
              url,
              props.groupId && !props.locationId ? props.groupId : undefined,
              props.locationId,
            );
          }}
        />

        <div className="titleSection">
          <h2>{name}</h2>
          {subText}
          <br />
          {subText2}
        </div>
        <div className="editButton">
          {props.isEditing ? (
            <Button
              color={ButtonColor.ORANGE}
              onClick={() => {
                const url = `${props.preamble}/page/${props.page}${props.subPage ? "/" + props.subPage : ""}`;
                navigate(url);
              }}
            >
              Done
            </Button>
          ) : (
            <Button
              onClick={() => {
                const url = `${props.preamble}/page/${props.page}${props.subPage ? "/" + props.subPage : ""}/edit`;
                navigate(url);
              }}
            >
              Edit <BiEdit />
            </Button>
          )}
        </div>
      </div>
      {infoContent}
      <div className="p-5">{props.children}</div>
    </div>
  );
}
